module.exports = __webpack_public_path__ + "static/birds-5cc533f764fc06e3f30d1149f52647a5.jpg";